"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.controls.knowledgePicker.label': 'Seleccionar Conocimiento',
    'ai.controls.knowledgePicker.show': 'Usar Base de Conocimientos',
};
